// TODO: replace with the real App Store id once Magic Crayons is released.
export const appStoreURL = "https://apps.apple.com/app/idAPP_ID_TBD";

export const supportEmail = "contact@aarstudio.com";
